import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_model.gif';
import type { ItemModel } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class ModelList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Model';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemModel;
        const authors = item.creator.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
            </>
        );
    }
}

export default ModelList;
